import React from 'react';
import TpClientPaymentTpClientInvoiceSearchParams from './TpClientPaymentTpClientInvoiceSearchParams';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import TpRelatedClientInvoiceService from '../../../Services/TpRelatedClientInvoiceService';
import ApplyPaymentItem from '../../../Domain/ApplyPaymentItem';
import TpClientPaymentService from '../../../Services/tpClientPaymentService';
import AppliedTpRelatednvoiceItem from '../../../Domain/AppliedTpRelatednvoiceItem';

export default class AppliedClientInvoiceAdmin extends React.Component {
  static defaultProps = {
    tpClientPaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      searchItem: new TpClientPaymentTpClientInvoiceSearchParams(
        props.tpClientPaymentId,
        'applied',
        'applied_tprelated'
      ),
    };

    this.refresh = this.refresh.bind(this);
    this.removePaymentFunction = this.removePaymentFunction.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  removePaymentFunction() {
    const selectedItem = new ApplyPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
    selectedItem.TpClientPaymentId = this.props.tpClientPaymentId;
    selectedItem.TpClientInvoiceIds = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    selectedItem.InvoiceType = 'applied';
    TpClientPaymentService.RemovePaymentFromOldInvoice(selectedItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Payment removed from Invoice(s).');
        }
        ErrorMessage.SetLoading(false);
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('ACIA57', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  renderButtons() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.removePaymentFunction),
              label: 'Remove Payment(s)',
              tooltip: 'Remove Payment(s)',
              roleKey: 'tp_clientpayment_remove',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
          ]}
        />
      </div>
    );
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Remove the payment of all currently selected (${this.state.numberOfElementsInTheTable}) Client Invoices?`;
    }
    const idList = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    return `Remove the payment of the selected ${idList.length} Client Invoice(s)?`;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtons()}
        <TabOfDataTable
          type={AppliedTpRelatednvoiceItem}
          serviceFunction={TpRelatedClientInvoiceService.ListTpRelatedApplied}
          convertDBItemsFunction={ClientInvoiceService.ConvertAppliedDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={TpClientPaymentTpClientInvoiceSearchParams}
          orderBy='CiId'
          orderDirection='Desc'
          errorCode='ACIA109'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          forceClearCacheOnSearch={true}
        />
      </div>
    );
  }
}
